<template>
  <div v-if="displayAsLink">
    <a :href="`tel:${display}`">{{ display }}</a>
  </div>
  <div v-else>
    {{ display }}
  </div>
</template>

<script>

import cellRendererMixin from '../../mixins/cellRenderer.mixin'

export default {
  mixins: [cellRendererMixin],
  computed: {
    displayAsLink() {
      return this.params.displayAsLink
    }
  }
}
</script>
